import { cn } from "@/lib/utils";
import { companyOf, logoFor } from "@/content/testimonials/logos";

/**
 * The company behind a testimonial, at the top of its card: the customer's own logo where we have it
 * (src/content/testimonials/logos.ts), else the company name set in type. Never a stand-in "logo".
 */
const TestimonialLogo = ({ role, className, onDark = false }: { role: string; className?: string; onDark?: boolean }) => {
  const company = companyOf(role);
  if (!company) return null;
  const logo = logoFor(role);
  if (logo) {
    return (
      <span className={cn("inline-flex h-12 items-center", logo.onDark && "rounded-md bg-[#121721] px-3", className)} data-testid="testimonial-logo">
        <img src={logo.src} width={logo.width} height={logo.height} alt={company} loading="lazy" decoding="async" className="block h-full w-auto max-w-[180px] object-contain" />
      </span>
    );
  }
  return (
    <span
      className={cn("inline-flex min-h-12 items-center font-display text-lg font-bold leading-tight tracking-[-0.01em]", onDark ? "text-white" : "text-foreground", className)}
      data-testid="testimonial-company"
    >
      {company}
    </span>
  );
};

export default TestimonialLogo;
